import {
  Dialog,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { Delete } from "@mui/icons-material";
import ConfirmationModal from "../../../App/Components/Modals/ConfirmationModal";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { Link } from "react-router-dom";
import { deleteEventSponsor, getEventSponsors } from "../EventSponsorsService";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  image: {
    maxWidth: "100px",
    height: "auto",
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function EventSponsorTableCell({
  columns,
  element,
  index,
  setTableData,
}) {
  const classes = useStyles();
  const [deleteModal, setDeleteModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const callDeleteSponsor = () => {
    callAPI(
      deleteEventSponsor(element.id),
      "Sponsor Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEventSponsors(element.clientId).then((response) => {
        response.forEach(
          (row) =>
            (row.imagePath = "data:" + row.contentType + ";base64," + row.logo)
        );
        setTableData(response);
      });
    });
  };

  function openModal(e) {
    e.preventDefault();
    setDeleteModal(true);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={index}
        component={Link}
        to={{ pathname: "/eventsponsors/eventsponsordetailed", state: element }}
      >
        {columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Delete" ? (
              <Tooltip title="Delete Featured Event">
                <IconButton onClick={(e) => openModal(e)} size="large">
                  <Delete />
                </IconButton>
              </Tooltip>
            ) : column.label === "Logo" ? (
              <img className={classes.image} src={element[column.propName]} />
            ) : (
              element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this event sponsor?"
          func={() => callDeleteSponsor()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
    </>
  );
}
